import { render, staticRenderFns } from "./SampleAnalysisParameters.vue?vue&type=template&id=3a240283&scoped=true&"
import script from "./SampleAnalysisParameters.vue?vue&type=script&lang=ts&"
export * from "./SampleAnalysisParameters.vue?vue&type=script&lang=ts&"
import style0 from "./SampleAnalysisParameters.vue?vue&type=style&index=0&id=3a240283&lang=scss&scoped=true&"
import style1 from "./SampleAnalysisParameters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a240283",
  null
  
)

export default component.exports